// AboutPage: agency information with centered engagements
import React from "react";
import AnimatedPage from "../components/AnimatedPage";
import SlideInWhenVisible from "../components/SlideInWhenVisible";
import SEO from "../components/SEO";

export default function AboutPage() {
  return (
    <AnimatedPage>
      <SEO
        title="About Us - Our Story & Mission"
        description="Since 2012, Moroccan Desert Trek has been creating unique experiences to discover Morocco. Certified guides, responsible tourism, and personalized adventures."
        path="/about"
      />
      <div className="space-y-12 px-4 py-8 md:px-16 md:py-12">
        {/* Header */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-extrabold text-slate-900 dark:text-white">
            About Morocco Tours
          </h1>
          <p className="max-w-2xl mx-auto text-lg text-slate-600 dark:text-slate-300">
            Since 2012, we have been creating unique experiences to discover the
            Morocco in all its colors: deserts, mountains, ocean, and imperial
            cities. Our local team is committed to offering responsible,
            immersive, and personalized tours.
          </p>
        </div>

        {/* Nos engagements */}
        <section className="text-center">
          <h2 className="mb-6 text-2xl font-bold text-emerald-600 dark:text-emerald-400">
            Our Commitments
          </h2>
          <div className="mx-auto grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 justify-items-center">
            {[
              "Certified and Passionate Guides",
              "Accommodations Selected for Charm and Comfort",
              "Safe and Adapted Transportation",
              "Respect for Communities and the Environment",
            ].map((item, index) => (
              <SlideInWhenVisible
                key={index}
                direction={"right"}
                delay={index * 0.2}
              >
                <div
                  key={index}
                  className="flex flex-col items-center rounded-xl border border-slate-200 bg-white p-6 shadow hover:scale-105 transition dark:border-slate-800 dark:bg-slate-900"
                >
                  <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-700 dark:text-white text-lg font-bold">
                    ✓
                  </div>
                  <p className="text-sm text-slate-700 dark:text-slate-300 text-center">
                    {item}
                  </p>
                </div>
              </SlideInWhenVisible>
            ))}
          </div>
        </section>

        {/* Call to action */}
        <SlideInWhenVisible direction={"right"} delay={0.3}>
          <section className="rounded-2xl bg-gradient-to-r from-emerald-600 to-emerald-500 p-8 text-white shadow-lg dark:from-emerald-700 dark:to-emerald-600 text-center">
            <h3 className="text-2xl font-bold">Ready to Discover Morocco?</h3>
            <p className="mt-2 opacity-90">
              Join our tours and live an unforgettable adventure.
            </p>
            <a
              href="/tours"
              className="mt-4 inline-block rounded-md bg-white px-5 py-3 font-semibold text-emerald-700 hover:bg-emerald-50"
            >
              View Tours
            </a>
          </section>
        </SlideInWhenVisible>
      </div>
    </AnimatedPage>
  );
}
